import { FC } from "react";
import styles from "./search-bar-results-item.module.css";
import { Product, useProductCardLogic } from "@commons-monorepo/index";
import { MainHeaderEvents } from "../../main-header.events";

interface SearchBarResultsItemProps {
  product: Product;
  locale: string;
  currency: string;
  onClick?: () => void;
}

const SearchBarResultsItem: FC<SearchBarResultsItemProps> = ({
  product,
  onClick,
  locale,
  currency
}) => {
  const {
    formattedFinalPrice,
    formattedWithoutDiscountPrice,
    hasDiscount,
    percentageDiscount,
    images,
    logEvent,
    goToProductDetail
  } = useProductCardLogic({ product, locale, currency });

  return (
    <div
      className={styles.searchBarResultsItemWrapper}
      onClick={() => {
        goToProductDetail("search_icon");
        logEvent(MainHeaderEvents.SelectSearchItem);
        onClick && onClick();
      }}>

      <img
        src={images[0].url}
        alt={images[0].tags?.join(", ")}
        className={styles.img} />

      <div className={styles.texts}>
        <div className={styles.name}>{product.name}</div>
        {hasDiscount &&
        <div className={styles.withoutDiscountPrice}>
            {formattedWithoutDiscountPrice}
          </div>}

        <div className={styles.prices}>
          <span className={styles.price}>{formattedFinalPrice}</span>
          {hasDiscount &&
          <div className={styles.discount}>{percentageDiscount}% OFF</div>}

        </div>
      </div>
      <div className={styles.arrowIcon}>
        <span className='icon-arrow' />
      </div>
    </div>);

};

export default SearchBarResultsItem;